import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { Button } from "../../button/src";
import { Link } from "../../link/src";
export const ButtonInLink = forwardRef((_a, ref) => {
    var { children, isDisabled = false, isFullWidth = false, linkProps = {}, wrapperProps = {} } = _a, otherProps = __rest(_a, ["children", "isDisabled", "isFullWidth", "linkProps", "wrapperProps"]);
    const defaultLinkProps = {
        style: { display: 'inline-flex' },
        to: '#',
    };
    const updatedLinkProps = Object.assign(Object.assign({}, defaultLinkProps), linkProps);
    return (_jsx(Box, Object.assign({ "data-testid": "button-in-link-wrapper", width: isFullWidth ? '100%' : undefined }, wrapperProps, { children: isDisabled ? (_jsx(Button, Object.assign({ as: "span", isDisabled: true, ref: ref, type: null }, otherProps, { children: children }))) : (_jsx(StyledLink, Object.assign({ width: isFullWidth ? '100%' : undefined }, updatedLinkProps, { children: _jsx(Button, Object.assign({ as: "span", isFullWidth: isFullWidth, ref: ref, type: null }, otherProps, { children: children })) }))) })));
});
const StyledLink = styled(Link) `
  text-decoration: none;

  & > span {
    line-height: 1.5;
  }

  &:hover {
    text-decoration: none;
  }
`;
//# sourceMappingURL=ButtonInLink.js.map